import React from "react";
import {TextField, Typography} from "@material-ui/core";
import StyleQuestionDetail from "../../../partial/styles/StyleQuestionDetail";
import {testTypes} from './../../../../config/constants';
import i18n from "i18next";

const TextInputQuestionDetail = (props) => {
    const {testTypeId, question} = props;
    const classes = StyleQuestionDetail();
    return (
        <React.Fragment>
            <TextField
                fullWidth
                margin="normal"
                variant="outlined"
                size="small"
                value={question.textInputStudentAnswer}
                disabled
            >
            </TextField>
            {
                testTypeId !== testTypes.BINH_CHON && testTypeId !== testTypes.KHAO_SAT ?
                    <div>
                        &nbsp;{i18n.t('correct_answer')} :
                        <Typography variant="subtitle1" display="inline" className={classes.correctAnswer}>
                            &nbsp;&nbsp;{question.textInputCorrectAnswer}
                        </Typography>
                    </div>
                    :
                    <></>
            }
        </React.Fragment>
    );
};

export default TextInputQuestionDetail;
